const ORDER_MUTABLE_FIELDS = [
  'order_no',
  'producer',
  'farmunit',
  'diversionPoint',
  'ditch',
  'division',
  'user',
  'flow',
  'original_cfs',
  'new_cfs',
  'net_cfs',
  'cfs_entry_mode',
  'run_date',
  'run_time',
  'type',
  'notes',
  'completed',
  'waterYear'
]

const ORDER_MUTABLE_FIELD_SET = new Set(ORDER_MUTABLE_FIELDS)

export const sanitizeOrderPayload = (payload = {}, { defaultCompleted = false, includeWaterYear = true } = {}) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload
  }

  const sanitized = Object.keys(payload).reduce((result, key) => {
    if (ORDER_MUTABLE_FIELD_SET.has(key) && (includeWaterYear || key !== 'waterYear')) {
      result[key] = payload[key]
    }

    return result
  }, {})

  if (defaultCompleted && sanitized.completed == null) {
    sanitized.completed = false
  }

  return sanitized
}
